import React, { useState } from 'react';

import { MenuModal } from '@/components/Messanger/MenuModal.tsx';
import {
  activeIndicatorStyle,
  avatarContainer,
  avatarImage,
  headerContainer,
  headerContent,
  menuContainer,
  nameContainer,
  seenRecentlyIndicatorStyle
} from '@/components/Messanger/Message/Header/styles.ts';
import HeaderSkeleton from '@/components/Messanger/Message/Header/HeaderSkeleton.tsx';
import { DotsVertical } from '@/components/common/svg/DotsVertical.tsx';
import { ReportModal } from '@/components/Messanger/ReportModal.tsx';
import Modal from '@/animations/Modal.tsx';
import { RelationKind, UserStates } from '@/enums/apiEnums.ts';
import { ImageWithLoader } from '@/components/common/Image/ImageWithLoader.tsx';
import UserProfilePopup from '@/components/Popup/UserProfile/UserProfilePopup.tsx';
import VerifiedBadgeShape from '@/components/common/svg/shapes/VerifiedBadgeShape.tsx';

interface HeaderProps {
  hid: string;
  avatar?: string;
  onlineState?: UserStates;
  name: string;
  isEmptyMessages: boolean;
  isSystem?: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  hid,
  avatar,
  onlineState,
  name,
  isEmptyMessages,
  isSystem
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [userProfileOpened, setUserProfileOpened] = useState<boolean>(false);
  const [userProfileHid, setUserProfileHid] = useState<string | undefined>(
    undefined
  );

  const closeMenu = () => setMenuOpen(false);
  const openMenu = () => setMenuOpen(true);

  const openReport = () => setReportOpen(true);
  const closeReport = () => setReportOpen(false);

  const closeUserProfile = () => {
    setUserProfileOpened(false);
    setUserProfileHid(undefined);
  };
  const openUserProfile = (userHid: string) => {
    setUserProfileHid(userHid);
    setUserProfileOpened(true);
  };

  const avatarSrc = avatar ? avatar : '';

  const renderUserState = () => {
    if (onlineState === UserStates.ONLINE_STATE_ONLINE) {
      return <div style={activeIndicatorStyle} />;
    }
    if (onlineState === UserStates.ONLINE_STATE_RECENTLY_SEEN) {
      return <div style={seenRecentlyIndicatorStyle} />;
    }
    return null;
  };

  return (
    <>
      <div style={headerContainer}>
        <div style={headerContent}>
          {!isEmptyMessages ? (
            <div
              onClick={() => {
                !isSystem && openUserProfile(hid);
              }}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <div style={avatarContainer}>
                <ImageWithLoader
                  style={avatarImage}
                  src={isSystem ? '/logo_new.png' : avatarSrc}
                  alt="avatar"
                  fallbackIconWidth={20}
                  fallbackIconHeight={30}
                />
              </div>
              <div style={nameContainer}>
                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                  {name}
                  {isSystem && (
                    <VerifiedBadgeShape
                      width={18}
                      height={18}
                      style={{ marginLeft: 5 }}
                    />
                  )}
                  {!isSystem && renderUserState()}
                </span>
              </div>
            </div>
          ) : (
            <HeaderSkeleton />
          )}
          {!isSystem && !isEmptyMessages && (
            <div style={menuContainer}>
              <div
                onClick={() => {
                  setTimeout(() => {
                    openMenu();
                  }, 150);
                }}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <DotsVertical />
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal open={menuOpen} handleClose={closeMenu}>
        <MenuModal
          id={hid}
          name={name}
          closeMenu={closeMenu}
          openReport={openReport}
        />
      </Modal>

      <Modal open={reportOpen} handleClose={closeReport}>
        <ReportModal
          id={hid}
          name={name}
          relationKind={RelationKind.KIND_MATCHED} // mock for block from menu
          handleClose={closeReport}
        />
      </Modal>

      <Modal fullScreen open={userProfileOpened} handleClose={closeUserProfile}>
        <UserProfilePopup
          handleClose={closeUserProfile}
          userHid={userProfileHid}
          hideBackButton={false}
          prevHeaderColors="light"
        />
      </Modal>
    </>
  );
};
